module.exports = __webpack_public_path__ + "static/media/TubeStand.eaef2438.svg";